import React from 'react';

import {
  Controller,
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';

import TimePicker from 'components/timePicker';
import { FormControl, SxProps } from '@mui/material';

interface TimeProps {
  label: string;
  margin?: 'normal' | 'dense' | 'none';
  sx?: SxProps;
}

export type TimeFormFieldProps<T extends FieldValues> = TimeProps &
  UseControllerProps<T>;

const TimeFormField = <T extends FieldValues>(props: TimeFormFieldProps<T>) => {
  const { label, name, control, margin = 'normal', sx } = props;

  const {
    formState: { errors },
  } = useController<T>({ name, control });

  return (
    <FormControl error={Boolean(errors[name])} margin={margin} sx={sx}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TimePicker
            {...field}
            onChange={field.onChange}
            value={field.value}
            label={label}
          />
        )}
      />
    </FormControl>
  );
};

export default TimeFormField;
